import React from 'react';
import { IonButtons, IonHeader, IonTitle, IonToolbar, useIonRouter, useIonToast } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { axius, images, types } from 'utils';
import { Modal, Spin, Switch } from 'antd';
import Radio from './Radio';
import { Button } from 'react-bootstrap';
import { Touchable } from './';


interface Props extends RouteComponentProps, types.StateProps {
    title: string;
};
const Header: React.FC<Props> = (props) => {

    const router = useIonRouter();

    const { history, _auth: { user, isLoggedIn } } = props;

    const [presentToast] = useIonToast();

    const [hour, setHour] = React.useState(0);
    const [onoff, setOnOff] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);

    const isOnline = user.preferences?.online;

    React.useEffect(() => {
        if (!history.location.pathname.includes('/orders/')) {
            props.dispatch(props.changeData('order', {}));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history.location.pathname]);

    const setOnOrOffLine = () => {
        if (isOnline) {
            setOnOff(true);
        } else {
            updateUserPreference({ online: true });
        }
    }

    const updateUserPreference = (v: any) => {
        setSubmitting(true);
        axius.put(`users/me`, { preferences: { ...v, offlineFor: hour } }).then((res: types.AxiusResponse) => {
            if (res.status === 200) {
                props.dispatch(props.changeAuth('user', res.data));
                close();
                presentToast({ message: `You are now ${v.online ? 'online' : 'offline'}`, duration: 1500 });
            } else {

            }
            setSubmitting(false);
        });
    }

    const close = () => {
        setHour(0);
        setOnOff(false);
    }

    const canGoBack =
        history.location.pathname !== '/orders' && (router.canGoBack());

    return (
        <React.Fragment>
            <IonHeader className="ion-no-border">
                <IonToolbar>
                    {canGoBack && (
                        <IonButtons slot="start">
                            <Touchable
                                shape="circle"
                                onClick={() => router.goBack()}
                                className="pl-1s"
                            >
                                <div className="pl-1s">
                                    <img src={images.ArrowLeftCircle} alt="ArrowLeftCircle" />
                                </div>
                            </Touchable>
                        </IonButtons>
                    )}
                    <IonTitle>
                        {props.title}
                    </IonTitle>
                    {isLoggedIn && (
                        <IonButtons slot="end">
                            <div className="d-flex align-items-center mr-4">
                                {/* <Touchable onClick={setOnOrOffLine}>
                                    <div className={`order-status ${isOnline ? 'success animate__flashs animate__slows' : 'warning animate__tada'} animate__animated animate__infinite`}>
                                        &nbsp; {isOnline ? 'Online' : 'Offline'} &nbsp;
                                    </div>
                                </Touchable> */}
                                <Switch
                                    checked={isOnline}
                                    onChange={setOnOrOffLine}
                                    checkedChildren="Online"
                                    unCheckedChildren="Offline"
                                />
                            </div>
                        </IonButtons>
                    )}
                </IonToolbar>
            </IonHeader>

            <Modal open={onoff} title={null} footer={null} centered width="85vw" closable={true} maskClosable={false} onCancel={close}>
                <Spin spinning={submitting}>
                    <div className="mb-1 fw-600">GO OFFLINE!</div>
                    <div className="mb-3">How long do you want to go offline for?</div>
                    {[[1, '1 hour'], [2, '2 hours'], [3, '3 hours'], [24, 'All day']].map(h => (
                        <div
                            key={h[1]}
                            className="d-flex align-items-center px-2 py-1 mr-2 mb-2"
                            style={{ background: '#eee', borderRadius: 45 }}
                            onClick={() => setHour(+h[0])}
                        >
                            <div style={{ opacity: hour === h[0] ? 1 : .3 }}>
                                <Radio selected={!!(hour === h[0])} height={17} />
                            </div>
                            <span className="ml-2 fs-12">{h[1]}</span>
                        </div>
                    ))}
                    <div>&nbsp;</div>
                    <Button variant="primary btn-block btn-md" disabled={hour === 0 ? true : false} onClick={() => updateUserPreference({ online: false })}>
                        Submit
                    </Button>
                </Spin>
            </Modal>
        </React.Fragment>
    );
}

export default Header;